<template>
  <div>
    <div v-if="$auth.user().workshop_access">
      <div v-if="$auth.user().subscription">
        <div v-if="workshops == ''">
          <div v-show="!loadingWorkshops">
            <card :class="'card-catalog-'+theme">
              <div class="card-header">
                <h4 class="card-title">
                  <i class="nc-icon nc-notification-70"></i> Oops!
                </h4>
              </div>
              <hr />
              <div class="card-body">
                <div class="text-center">
                  <h2 class="card-title text-center">
                    <small>Wall Street, we have a problem...</small>
                  </h2>
                  <h2 class="card-title text-center">
                    <small>
                      No momento, não há especializações agendados em sua conta.
                      <br />Entre em contato com o suporte para mais informações.
                    </small>
                  </h2>
                </div>
              </div>
            </card>
          </div>
        </div>

        <div v-else>
          <div v-show="!loadingWorkshops">
            <div v-if="open==='ListWorkshops'&&workshops">
              <h4>
                <small>
                  <a class="btn text-white" @click.prevent="fetchWorkshops()">
                    <i class="nc-icon nc-bullet-list-67"></i> Próximas Especializações
                  </a>
                </small>
              </h4>
              <div class="row">
                <div class="col-md-4" v-for="(workshop, index) in workshops" :key="workshop.id">
                  <div
                    class="row"
                    v-if="loadingWorkshops"
                    v-loading="loadingWorkshops"
                    id="loading"
                  ></div>
                  <card v-if="!loadingWorkshops" :class="'card-catalog-'+theme">
                    <div class="card-header text-center">
                      <h4 class="card-title">
                        <small>
                          <i class="nc-icon nc-tv-2"></i>
                        </small>
                        {{workshop.workshop.data.name}}
                      </h4>
                    </div>
                    <hr />
                    <div class="card-boby text-center">
                      <h4 class="card-title">
                        <small>
                          <i class="nc-icon nc-time-alarm"></i>
                        </small>
                        {{ workshop.date }} às {{workshop.time}}Hrs
                      </h4>
                      <hr />
                      <button
                        class="btn btn-default btn-wd"
                        :disabled="!workshop.available"
                        @click.prevent="openWorkshop(index)"
                      >
                        <i class="nc-icon nc-tap-01"></i> Acessar
                      </button>
                    </div>
                  </card>
                </div>
              </div>
            </div>

            <div class="row" v-if="open=='ShowWorkshop'">
              <div class="col-md-12" v-if="!workshopEventConfirmed">
                <div class="row" v-if="submittingEvent" v-loading="submittingEvent" id="loading"></div>
                <card v-if="!submittingEvent" :class="'card-catalog-'+theme">
                  <div class="card-header text-center">
                    <h4 class="card-title">Aceita participar do seguinte evento?</h4>
                  </div>
                  <hr />
                  <div class="card-boby text-center">
                    <h4 class="card-title">
                      Especialização de {{workshop.workshop.data.name}}
                      em {{ workshop.date | moment("DD/MM/YYYY") }} às {{workshop.time}} hrs.
                    </h4>
                    <hr />
                    <button
                      class="btn btn-default btn-wd"
                      :disabled="!workshop.available"
                      @click.prevent="submitWorkshopEvent()"
                    >Sim, aceito.*</button>
                    <button
                      class="btn btn-danger btn-wd"
                      @click.prevent="fetchWorkshops()"
                    >Cancelar.</button>
                  </div>
                  <hr />
                  <h6 class="card-subtitle">
                    * Se você iniciar qualquer uma das especializações, deve completá-la na mesma turma, caso você inicie e não conclua, a mesma não se encontrará mais disponível no próximo mês pois se tratará de uma nova turma e a que você começou a assistir se dará por encerrada
                    <br />* Sua participação neste evento será registrada em nosso banco de dados para fins de controle de presença.
                    <br />* Ao aceitar o acesso a este evento, declaro estar ciente que toda atividade da TopTrader é única e exclusivamente educacional.
                    <br />* O presente evento trata-se de uma Especialização de Aprofundamento Educacional e a aplicação do conhecimento obtido no mesmo é de minha inteira responsabilidade.
                  </h6>
                </card>
              </div>
            </div>

            <div class="col-md-12" v-if="workshopEventConfirmed">
              <card v-if="workshopEventConfirmed" :class="'card-catalog-'+theme">
                <div class="card-header text-center">
                  <h4 class="card-title">Partipação validada com sucesso!</h4>
                </div>
                <hr />
                <div class="card-boby text-center">
                  <h4 class="card-title">
                    Especialização: {{workshop.workshop.data.name}}
                    <br />
                    Horário: {{ workshop.date | moment("DD/MM/YYYY") }} às {{workshop.time}}
                  </h4>
                  <h3
                    class="card-title text-center text-danger"
                  >Obs.: Desative seu microfone após entrar na Sala.</h3>
                  <hr />
                  <a
                    class="btn btn-default btn-wd"
                    :href="workshop.workshop.data.link"
                    target="blank"
                  >Entrar na Sala</a>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <card :class="'card-catalog-'+theme">
          <div class="card-header">
            <h4 class="card-title">
              <i class="nc-icon nc-notification-70"></i> Oops!
            </h4>
          </div>
          <hr />
          <div class="card-body">
            <div class="text-center">
              <h2 class="card-title text-center">
                <small>Wall Street, we have a problem...</small>
              </h2>
              <h2 class="card-title text-center">
                <small>Você não possui assinatura ativa para continuar acompanhando as Salas de Conferência.</small>
              </h2>
              <br />
              <router-link
                class="btn btn-round btn-fill"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                to="/signature"
                href="/performance"
              >Nova Assinatura</router-link>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div v-else>
      <card
        class="col-lg-12 col-md-12"
        v-if="!$auth.user().workshop_access"
        :class="'card-catalog-'+theme"
      >
        <div class="card-header">
          <h4 class="card-title">
            <i class="nc-icon nc-notification-70"></i> Oops!
          </h4>
        </div>
        <hr />
        <div class="card-body">
          <div class="text-center">
            <h2 class="card-title text-center">
              <small>Wall Street, we have a problem...</small>
            </h2>
            <h2 class="card-title text-center">
              <small>
                Você ainda não possui acesso à página de Especializações.
                <br />Entre em contato com o suporte para mais informações.
              </small>
            </h2>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "element-ui";
import moment from "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo");
Vue.use(Loading.directive);

export default {
  components: {},
  data() {
    return {
      submittingEvent: false,
      loadingWorkshops: true,
      workshopAccess: false,
      workshops: [],
      workshop: {},
      workshopEventConfirmed: false,
      open: ""
    };
  },
  methods: {
    fetchWorkshops() {
      this.workshopEventConfirmed = false;
      this.loadingWorkshops = true;
      this.axios
        .get("/workshops")
        .then(response => {
          if (response.data.data) {
            this.workshops = response.data.data;
            this.workshops.forEach(workshop => {
              workshop.date = moment(workshop.date, 'YYYY-MM-DD').format("DD/MM/YYYY");
            });
            this.open = "ListWorkshops";
          }
          this.loadingWorkshops = false;
        })
        .catch(error => {
          alert("Erro ao carregar Workshops. Tente novamente. \n " + error);
          console.log(error);
          this.loadingWorkshops = false;
        });
    },
    openWorkshop(workshopIndex) {
      this.open = "ShowWorkshop";
      this.workshop = this.workshops[workshopIndex];
      let userName = this.$auth.user().name + "";
      let userSurname = this.$auth.user().surname + "";
      let userEmail = this.$auth.user().email + "";
      this.workshop.workshop.data.link =
        "https://toptrd.webex.com/toptrd/m.php?AT=JM&MK=1322587916&AN=" +
        userName.toUpperCase() +
        " " +
        userSurname.toUpperCase() +
        " - " +
        userEmail +
        "&AE=" +
        userEmail.toUpperCase() +
        "&BU=https://aluno.top-trader.org/#/confroomevaluation";
    },
    submitWorkshopEvent() {
      let eventData = {
        click_action: true,
        confirmed_click_action: true,
        workshop_schedule_id: this.workshop.id
      };
      this.axios
        .patch("/studentworkshophistory", eventData)
        .then(response => {
          this.workshopEventConfirmed = true;
        })
        .catch(error => {
          alert("Erro ao acessar Workshop. Tente novamente.\n " + error);
          console.log(error);
        });
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchWorkshops();
  }
};
</script>
<style>
.card-catalog-black {
  background-color: #2a2b31;
}
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Workshop.vue